import API from "../utilities/LocalApiProxy";
import { openGlobalSnackbar } from "./globalSnackbarActions";
import {
	documentMap,
	emailMap,
	notesMap,
	directoryMap,
} from "../utilities/itemMappers";

function mapItems(items, itemType) {
	if (itemType === "docs") {
		return documentMap(items.filter((i) => i.documentID)).concat(
			directoryMap(
				items.filter((i) => i.folderID),
				"File"
			)
		);
	}
	if (itemType === "email") {
		return emailMap(items.filter((i) => i.emailID)).concat(
			directoryMap(
				items.filter((i) => i.folderID),
				"Email"
			)
		);
	}
	if (itemType === "notes") {
		return notesMap(items.filter((i) => i.noteID)).concat(
			directoryMap(
				items.filter((i) => i.folderID),
				"Note"
			)
		);
	}
	return [];
}

export function listNonNormalItems({
	matterID,
	basepath,
	itemType,
	lifecycleStatusToGet,
}) {
	return function (dispatch) {
		dispatch({ type: "GET_NON_NORMAL_ITEMS_REQUEST" });
		API.post("/matter/nonNormalItems/list", {
			body: { matterID, basepath, itemType, lifecycleStatusToGet },
		})
			.then((results) => {
				dispatch({
					type: "GET_NON_NORMAL_ITEMS_SUCCESS",
					payload: {
						items: mapItems(results.mysql.items, itemType),
					},
				});
			})
			.catch((err) => {
				dispatch({ type: "GET_NON_NORMAL_ITEMS_FAILURE" });
				// LexWorkplace errors are already shown by handleLexworkplaceAPIError
				if (!err?.lxwErrorCode) {
					openGlobalSnackbar({
						message: "There was a problem loading this list.",
						variant: "error",
					})(dispatch);
				}
			});
	};
}
